import { StatusPair } from '../models/status-pair';

export class ExplanationData {
    private explanationList: StatusPair[] = [
        new StatusPair('Not disclosed', 'TIN_NOT_DISCLOSED'),
        new StatusPair('Not required', 'TIN_NOT_REQUIRED'),
        new StatusPair('Not Issued', 'TIN_NOT_ISSUED')];

    public getExplanationList(): Array<StatusPair> {
        return this.explanationList;
    }
}
